import { dossiers } from '@/mocks/homeData';
import SectionHead from './SectionHead';

export default function DossierReading() {
  return (
    <section id="shen-du" className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
      <SectionHead
        index="档案 05"
        kicker="深度档案"
        title="把一条线从头捋到尾"
        desc="最新实锤是抓点，深度档案是连线。把一次曝光前后的材料按时间排开，看它到底是怎么一步步走成这样的。"
      />

      <div className="mt-10 space-y-5">
        {dossiers.map((d) => (
          <article
            key={d.title}
            className="group grid grid-cols-1 items-center gap-5 rounded-lg bg-background-100 p-4 transition-colors duration-200 hover:bg-background-200/60 md:grid-cols-12 md:gap-8"
          >
            <div className="relative overflow-hidden rounded-md md:col-span-4">
              <div className="aspect-[3/2] w-full md:aspect-[4/3]">
                <img
                  src={d.thumb}
                  alt={d.thumbAlt}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <span className="absolute left-2.5 top-2.5 flex items-center gap-1.5 rounded-md bg-foreground-950/85 px-2.5 py-1 text-xs font-medium text-background-50">
                <i className={d.kickerIcon} aria-hidden="true"></i>
                {d.kicker}
              </span>
            </div>

            <div className="md:col-span-8">
              <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-500">
                <span className="flex items-center gap-1.5">
                  <i className="ri-time-line" aria-hidden="true"></i>
                  {d.date}
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-book-open-line" aria-hidden="true"></i>
                  {d.minutes}
                </span>
              </div>
              <h3 className="mt-2 font-heading text-lg font-bold leading-snug text-foreground-950 transition-colors duration-200 group-hover:text-primary-700 md:text-xl">
                {d.title}
              </h3>
              <p className="mt-2.5 max-w-3xl text-sm leading-relaxed text-foreground-600">{d.summary}</p>
              <a
                href="#shen-du"
                className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 transition-colors duration-200 hover:text-primary-700 cursor-pointer"
              >
                展开完整时间线
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </a>
            </div>
          </article>
        ))}
      </div>

      <div className="mt-8 flex justify-center">
        <a
          href="#zui-xin"
          className="flex h-11 items-center justify-center rounded-md border border-foreground-200 px-6 text-sm text-foreground-800 whitespace-nowrap transition-colors duration-200 hover:border-primary-300 hover:text-primary-700 cursor-pointer"
        >
          加载更多档案
          <i className="ri-loader-4-line ml-2" aria-hidden="true"></i>
        </a>
      </div>
    </section>
  );
}